import { Button } from '@mui/material';
import RouteIcon from '@mui/icons-material/Route';
import { useNavigate } from 'react-router-dom';
import type { SxProps, Theme } from '@mui/material';

export interface LinkedToTripButtonProps {
    trip: { id: string; name?: string | null };
    /** When provided, called on click (e.g. to stopPropagation in a list). Otherwise navigates to trip. */
    onClick?: (e: React.MouseEvent) => void;
    sx?: SxProps<Theme>;
}

export default function LinkedToTripButton({ trip, onClick, sx }: LinkedToTripButtonProps) {
    const navigate = useNavigate();

    const handleClick = (e: React.MouseEvent) => {
        if (onClick) {
            onClick(e);
        } else {
            navigate(`/logistics/trip/${trip.id}`);
        }
    };

    return (
        <Button
            size="small"
            variant="outlined"
            startIcon={<RouteIcon />}
            onClick={handleClick}
            sx={[{ textTransform: 'none' }, ...(Array.isArray(sx) ? sx : [sx].filter(Boolean))]}
        >
            Linked to trip: {trip.name ?? 'Trip'}
        </Button>
    );
}
